import { makeStyles } from "@material-ui/styles";

const drawerWidth = 240;

export default makeStyles(theme => ({
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap"
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1
    }
  },
  menu: {
    flex: 1
  },
  menuItem: {
    fontSize: 24,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.primary
  },
  menuAction: {
    "&:hover": {
      opacity: 1,
      color: theme.palette.text.primary
    }
  },
  item: {
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 24,
    paddingRight: 24,
    color: theme.palette.text.primary
  },
  itemCategory: {
    paddingTop: 16,
    paddingBottom: 16
  },
  activeItem: {
    color: theme.palette.primary.light
  },
  itemPrimary: {
    color: "inherit",
    fontSize: theme.typography.fontSize,
    overflow: "hidden",
    "&$textDense": {
      fontSize: theme.typography.fontSize
    }
  },
  textDense: {},
  divider: {
    marginTop: theme.spacing()
  },
  link: {
    textDecoration: "none"
  }
}));
